import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'

import { toastWithErrorMessage } from 'Helpers/toast'
import { colors } from 'Constants'
import UserStore from 'Store/user'

import PatientsService from 'Services/patients'
import TcodesService from 'Services/tcodes'
import EncounterList from './EncounterList'
import Header from './Header'

const TcodesContainer = styled.div`
  padding: 32px;
  overflow-y: scroll;
`

const ListContainer = styled.div`
  padding-top: 50px;
  padding-bottom: 50px;
  max-width: 900px;
  margin: auto;

  > * + * {
    margin-top: 30px;
  }
`

export default ({ medicalRef, title }) => {
  const [patientTCodes, setPatientTCodes] = useState([])

  useEffect(async () => {
    const { virtualOffices } = UserStore.get()

    const patients = await PatientsService.get({
      virtualOfficeId: virtualOffices[0]?.id,
      appCodes: virtualOffices[0]?.appCodes,
      mrn: medicalRef
    }).catch(toastWithErrorMessage('Failed to get patients'))

    let tcodes = []
    if (patients && patients.length > 0) {
      const patientIds = patients.map(item => item.PID)
      tcodes = await TcodesService.get({
        patientIds
      }).catch(toastWithErrorMessage('Failed to get tcodes'))
    }

    setPatientTCodes(tcodes)
  }, [medicalRef])

  return (
    <>
      <Header title={title} tCodes={patientTCodes} medicalRef={medicalRef} />
      <TcodesContainer>
        <ListContainer>
          {patientTCodes.length > 0 &&
            patientTCodes.map((item, idx) => {
              return (
                <>
                  <EncounterList
                    tid={item.TID}
                    tcode={item.t_code}
                    deleted={item.deleted}
                    journeyName={item.journeyName}
                    groupName={item.groupName}
                    officeId={item.officeId}
                    medicalRef={medicalRef}
                  />
                  {patientTCodes.length - 1 !== idx && (
                    <hr
                      style={{
                        height: 2,
                        width: '100%',
                        backgroundColor: colors.background900,
                        borderWidth: 0
                      }}
                    />
                  )}
                </>
              )
            })}
        </ListContainer>
      </TcodesContainer>
    </>
  )
}
